import { DismissibleAlertBanner } from "@/components/banners/DismissibleAlertBanner";

const DOC_URL =
  "https://docs.myaltimate.com/discover/setupui/#step-1-create-a-dbt-core-connection";

export function DbtConnectionMigrationBanner() {
  return (
    <DismissibleAlertBanner
      bannerId="dbt-core-connection-migration"
      title="Integrations have moved"
      content={
        <>
          New integrations are now created under Connections, enhancing
          experience and unlocking the ability to upload additional dbt
          artifacts.{" "}
          <a
            href={DOC_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="al-underline al-font-semibold"
          >
            View updated documentation
          </a>
        </>
      }
    />
  );
}
